const DEV = import.meta.env.DEV;
const PROD = import.meta.env.PROD;
const MODE = import.meta.env.MODE;
const PACKAGE_VERSION = import.meta.env.PACKAGE_VERSION;

export const ENV_CONFIG = { DEV, PROD, MODE, PACKAGE_VERSION };
